import { expirationPeriodOptions } from 'components/SecureDataSharing/contastants';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_DATE_TIME_FORMAT,
  MONTH_DAY_DATE_FORMAT,
  SHORT_DATE_FORMAT,
} from 'constants/dates';
import moment from 'moment';

/**
 * Parses a date string as UTC and formats it in the user's local timezone.
 * Example: "15:00" UTC → "16:00" in Poland (CET/CEST).
 */
export const getFormattedDate = (date: string, format: string = DEFAULT_DATE_FORMAT): string => {
  if (!date) return '';

  try {
    // Parse as UTC then convert to local time (e.g. 15:00 UTC → 16:00 in Poland)
    const dateObj = typeof date === 'string' ? moment.utc(date).local().toDate() : date;

    if (Number.isNaN(dateObj.getTime())) {
      const momentDate = moment.utc(date).local();

      const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
        month: '2-digit',
        day: '2-digit',
      });

      return formatter.format(momentDate.toDate());
    }

    if (format === SHORT_DATE_FORMAT) {
      const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });

      return formatter.format(dateObj);
    }

    if (format === DEFAULT_DATE_FORMAT) {
      const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      return formatter.format(dateObj);
    }
    if (format === MONTH_DAY_DATE_FORMAT) {
      const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
        month: '2-digit',
        day: '2-digit',
      });

      return formatter.format(dateObj);
    }
    if (format === DEFAULT_DATE_FORMAT) {
      const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
      });

      return formatter.format(dateObj);
    }
    if (format === DEFAULT_DATE_TIME_FORMAT) {
      const formatter = new Intl.DateTimeFormat(navigator.language || 'en-US', {
        hour: '2-digit',
        minute: '2-digit',
      });

      return formatter.format(dateObj);
    }
    return moment.utc(date).local().format(format);
  } catch (error) {
    return date ? moment.utc(date).local().format(format) : '';
  }
};

export const getExpirationDateUtc = (value: string): string => {
  switch (value) {
    case expirationPeriodOptions.day.value:
      return moment(new Date()).add(1, 'day').toISOString();
    case expirationPeriodOptions.sevenDays.value:
      return moment(new Date()).add(7, 'd').toISOString();
    case expirationPeriodOptions.tenDays.value:
      return moment(new Date()).add(10, 'd').toISOString();
    case expirationPeriodOptions.month.value:
      return moment(new Date()).add(1, 'month').toISOString();
    case expirationPeriodOptions.year.value:
      return moment(new Date()).add(1, 'year').toISOString();
    case expirationPeriodOptions.never.value:
      return moment(new Date()).set('year', 3000).toISOString();
    default:
      return moment(new Date()).add(1, 'day').toISOString();
  }
};
